import { useState, useEffect, type ReactNode } from 'react';
import { loadSaved, persistConfig } from '../../utils/storage';
import { ConfigContext } from './context';

type ConfigProviderProps = {
  children: ReactNode;
  activeProjectId?: string;
};

export const ConfigProvider = ({
  children,
  activeProjectId,
}: ConfigProviderProps) => {
  const saved = loadSaved();
  const [token, setToken] = useState(saved.token);
  const [refreshToken, setRefreshToken] = useState(saved.refreshToken);
  const [projectId, setProjectId] = useState(activeProjectId ?? saved.projectId);
  const [apiUrl, setApiUrl] = useState(saved.apiUrl);
  const [tokenApiUrl, setTokenApiUrl] = useState(saved.tokenApiUrl);

  useEffect(() => {
    if (activeProjectId) setProjectId(activeProjectId);
  }, [activeProjectId]);

  useEffect(() => {
    persistConfig(token, refreshToken, projectId, apiUrl, tokenApiUrl);
  }, [token, refreshToken, projectId, apiUrl, tokenApiUrl]);

  return (
    <ConfigContext.Provider
      value={{
        token,
        setToken,
        refreshToken,
        setRefreshToken,
        projectId,
        setProjectId,
        apiUrl,
        setApiUrl,
        tokenApiUrl,
        setTokenApiUrl,
      }}
    >
      {children}
    </ConfigContext.Provider>
  );
};
